import $ from 'jquery';
import { standardAjaxPost } from 'stdjs/standard-ajax';

export function PGSBlock({
  selector,
  showGroups = true,
  showSubGroups = true,
  showPlots = true,
  showPlotDetail = true,
  enableDrillDownClick = true,
  enableFilters = true,
  preSelectSingle = false,
  itemClickCallback,
  onPlotLoaded,
  plotsUrl,
  plotUrl,
  updatePgsSessionDetailsUrl,
}){
  
  var $selector = $(selector);
  var projectBlock = $selector.find(".project-list").closest(".card");
  var groupBlock = $selector.find(".group-list").closest(".card");
  var subgroupBlock = $selector.find(".subgroup-list").closest(".card");
  var plotBlock = $selector.find(".plot-list").closest(".card");
  var plotDetailBlock = $selector.find(".plot-detail").closest(".card");
  var detailBlock = $selector.find("#detail-pgs");

  if (!showGroups){
    groupBlock.hide();
  }
 
  if (!showSubGroups){
    subgroupBlock.hide();
  }

  if (!showPlots){
    plotBlock.hide();
  }

  if (!showPlotDetail){
    plotDetailBlock.hide();
  }

  /**
   * If drilldown is enabled then we can load the relevant groups/subgroups/plots
   */
  if (enableDrillDownClick){

    $(document).on("click", selector + " .pgs-item .drilldown", function(e){

      var pgsItem = $(this).closest(".pgs-item");
      var itemId = pgsItem.attr("data-id");
      var pgsItemType = pgsItem.attr("data-type");
      var updateSession = true;

      setActive(pgsItem, false);
      setPGSBreadcrumb();
      init();

      var pgsSessionData = {
        "PROJ10_ID": null,
        "PROJ20_ID": null,
        "PROJ30_ID": null,
      }

      if (pgsItemType === "*PROJECT"){
        loadGroups(itemId);        

       pgsSessionData.PROJ10_ID = itemId;

      }

      if (pgsItemType === "*GROUP"){

        if (pgsItem.attr("data-has-plots") === "true"){
          updateSession = false;
          loadPlots(itemId, pgsItemType)
        } else {
          loadSubGroups(itemId);
        }        

        pgsSessionData.PROJ10_ID = pgsItem.attr("data-project");
        pgsSessionData.PROJ20_ID = itemId;
      }

      if (pgsItemType === "*SUBGROUP"){
        updateSession = false;
        loadPlots(itemId, pgsItemType);
      }

      if (pgsItemType === "*PLOT"){
        updateSession = false;
        loadPlot(itemId);
      }

      if (updatePgsSessionDetailsUrl && updateSession){

        var successCallback = function(data){

        } 

        standardAjaxPost(updatePgsSessionDetailsUrl, pgsSessionData, successCallback, null, false);
      }

    });
    
  }

  if (enableFilters){

    $(document).on("keyup", "input.pgs-filter", function(){

        var searchText = $(this).val().toUpperCase();
        var block = $(this).closest(".card").find(".pgs-list");

        block.find(".pgs-item[data-active='true']").each(function(){
          var text = $(this).find(".name").text().toUpperCase();

          if (text.indexOf(searchText) == -1){
              $(this).addClass("hidden");
          } else {
              $(this).removeClass("hidden");
          }

        });
    });

    $(document).on("click", "button.pgs-filter-clear", function(){
      var input = $(this).closest(".card").find(".pgs-filter");
      input.val("");
      input.trigger("keyup");
    });
  }

  /**
   * If the block is clicked rather then the drill icon
   */
  if (itemClickCallback){
      $(document).on("click", selector + " .pgs-item .name", function(e){

        detailBlock.find(".card section").html("");
        detailBlock.find(".pgs-breadcrumb").html("");

        setActive($(this).closest(".pgs-item"), false);
        setPGSBreadcrumb();

        itemClickCallback($(this).closest(".pgs-item").attr("data-id"), $(this).closest(".pgs-item").attr("data-type"), $(this).closest(".pgs-item") );

      });
  }

  if (preSelectSingle){
    triggerPreSelect();
  }
  
  $(document).on("click", ".RESYNC_ENTITY", function(e){
  
    var content = $(this).closest(".popover-content");

    var pgsItem;
    if (content.attr("data-type") === "*GROUP"){
      pgsItem = groupBlock.find(".pgs-item[data-id='" + content.attr("data-id") + "']");
    }

    if (content.attr("data-type") === "*SUBGROUP"){
      pgsItem = subgroupBlock.find(".pgs-item[data-id='" + content.attr("data-id") + "']");
    }

    var data = "ID=" + content.attr("data-id");
    data += "&TYPE=" + content.attr("data-type");

    var successCallback = function(data){
      pgsItem.find(".popover").remove();
      pgsItem.find(".refresh-requested").removeClass("hidden");
    } 

    standardAjaxPost(resyncEntityUrl, data, successCallback, null, true);
  });

  //setScrollPosition();

  function triggerPreSelect(){

    setTimeout(function(){

      init();

      var projects = projectBlock.find(".pgs-item");
      if (projects.length === 1){
        setActive($(projects[0]), true);
      }

      var groups = groupBlock.find(".pgs-item");
      if (groups.length === 1 ){
        setActive($(groups[0]), true);
      }

      var subgroups = subgroupBlock.find(".pgs-item");
      if (subgroups.length === 1){
        setActive($(subgroups[0]), true);
      }
 
    }, 100);

  }

  function setScrollPosition(){

    var projects = projectBlock.find(".pgs-item.active");
    if (projects.length > 0){
      projectBlock.find(".pgs-item.active")[0].scrollIntoView();
    }

    var groups = groupBlock.find(".pgs-item.active");
    if (groups.length > 0){
      groupBlock.find(".pgs-item.active")[0].scrollIntoView();
    }
    
    var subgroups = subgroupBlock.find(".pgs-item.active");
    if (subgroups.length > 0){
      subgroupBlock.find(".pgs-item.active")[0].scrollIntoView();
    }

    var plots = plotBlock.find(".pgs-item.active");
    if (plots.length > 0){
      plotBlock.find(".pgs-item.active")[0].scrollIntoView();
    }
    
  }

  function setActive(pgsItem, preLoad = false){

    var id = pgsItem.attr("data-id");
    var type = pgsItem.attr("data-type");

    if (type === "*PROJECT"){
      
      /**
       * Remove any active classes
       */
      if (!preLoad){

        clearActive(projectBlock);
        clearActive(groupBlock);
        clearActive(subgroupBlock);
        clearActive(plotBlock);

        clearGroups();
        clearSubGroups();
      }

      /**
       * Add active class
       */
      if (!preLoad){
        pgsItem.addClass("active");
        pgsItem.removeClass("light");
      }
    }

    if (type === "*GROUP"){

      /**
       * Remove any active classes
       */
      if (!preLoad){
        clearActive(groupBlock);
        clearActive(subgroupBlock);
        clearActive(plotBlock);

        clearSubGroups();
      }

      /**
       * Add active class
       */
      projectBlock.find(".pgs-item.active").addClass("light");
      if (!preLoad){
        pgsItem.addClass("active");
        pgsItem.removeClass("light");
      }
    }

    if (type === "*SUBGROUP"){
      /**
       * Remove any active classes
       */
     if (!preLoad){
        clearActive(subgroupBlock);
        clearActive(plotBlock);
      }

      /**
       * Add active class
       */
      projectBlock.find(".pgs-item.active").addClass("light");
      groupBlock.find(".pgs-item.active").addClass("light");
      if (!preLoad){
        pgsItem.removeClass("light");
        pgsItem.addClass("active");
      }
    }

    if (type === "*PLOT"){
      /**
       * Remove any active classes
       */
      clearActive(plotBlock);

      /**
       * Add active class
       */
      subgroupBlock.find(".pgs-item.active").addClass("light");
      pgsItem.addClass("active");
    }
  }

  function setPGSBreadcrumb(){

    if (projectBlock.find(".pgs-item.active").length > 0){
      $("#PROJECT_CRUMB").html(projectBlock.find(".pgs-item.active .name").text());
    } else {
      $("#PROJECT_CRUMB").prev().addClass("hidden");
      $("#PROJECT_CRUMB").html("");
    }
    
    if (groupBlock.find(".pgs-item.active").length > 0){
      $("#GROUP_CRUMB").prev().removeClass("hidden");
      $("#GROUP_CRUMB").html(groupBlock.find(".pgs-item.active .name").text());
    } else {
      $("#GROUP_CRUMB").prev().addClass("hidden");
      $("#GROUP_CRUMB").html("");
    }

    if (subgroupBlock.find(".pgs-item.active").length > 0){
      $("#SUBGROUP_CRUMB").prev().removeClass("hidden");
      $("#SUBGROUP_CRUMB").html(subgroupBlock.find(".pgs-item.active .name").text());
    } else {
      $("#SUBGROUP_CRUMB").prev().addClass("hidden");
      $("#SUBGROUP_CRUMB").html("");
    }

    $("#PGS_CRUMB_CONTAINER").removeClass("hidden");
  }

  function clearActive(list){
    list.find(".pgs-item").removeClass("active");
    list.find(".pgs-item").removeClass("light");
  }

  function clearPlots(){
    plotBlock.find(".plot-list").html("");
  }

  function clearPlotDetail(){
    plotDetailBlock.find("header .plot-detail-title").html("");
    plotDetailBlock.find("header .plot-detail-status").html("");
    plotDetailBlock.find("#GROUP_ACTIONS").remove();
    plotDetailBlock.find(".plot-detail").html("");
  }

  function clearGroups(){
    groupBlock.find(".group-list .pgs-item").addClass("hidden");
    groupBlock.find(".group-list .pgs-item").removeAttr("data-active");
  }

  function clearSubGroups(){
    subgroupBlock.find(".subgroup-list .pgs-item").addClass("hidden");
    subgroupBlock.find(".subgroup-list .pgs-item").removeAttr("data-active");
  }

  function loadGroups(projectId){

    /**
     * Clear any currently loaded plots
     */
    clearSubGroups();
    clearPlots();
    clearPlotDetail();

    /**
     * Show relevant groups
     */
    groupBlock.find(".group-list .pgs-item").addClass("hidden");
		groupBlock.find(".group-list .pgs-item").attr("data-active", false);
    groupBlock.find(".group-list .pgs-item[data-project='" + projectId + "']").removeClass("hidden");
    groupBlock.find(".group-list .pgs-item[data-project='" + projectId + "']").attr("data-active", true);
  }

  function loadSubGroups(groupId){

     /**
     * Clear any currently loaded plots
     */
    clearPlots();
    clearPlotDetail();

    /**
     * Sometimes there are no subgroups within a group, if there are non the attempt to load any plots
     * for the group
     */
    var subGroups = subgroupBlock.find(".subgroup-list .pgs-item[data-group='" + groupId + "']");

    subgroupBlock.find(".subgroup-list .pgs-item").addClass("hidden");
		subgroupBlock.find(".subgroup-list .pgs-item").attr("data-active", false);

    subGroups.removeClass("hidden");
    subGroups.attr("data-active", true);
  }

  function loadPlots(id, type){

    var data = "ID=" + id;
    data += "&TYPE=" + type;

    /**
     * Clear any currently loaded plots
     */
    clearPlots();
    clearPlotDetail();

    $("html, body").animate({ scrollTop: plotBlock.find(".plot-list").offset().top - 200 }, 500);
    plotBlock.addClass("loading");
    
    var successCallback = function(data){
      plotBlock.removeClass("loading");
      plotBlock.find(".plot-list").html(data.html);
    };

    standardAjaxPost(plotsUrl, data, successCallback, null, false);
  }

  function loadPlot(id){

    var data = "ID=" + id;

    /**
     * Clear currently loaded plot detail
     */
    clearPlotDetail();

    plotDetailBlock.addClass("loading");

    var successCallback = function(data){
      updatePlotDetail( data );
    };

    standardAjaxPost(plotUrl, data, successCallback, null, false);
  }
  
  function updatePlotDetail( data ){
    plotDetailBlock.removeClass("loading");
    plotDetailBlock.find(".plot-detail").html(data.html);
    plotDetailBlock.find("header .plot-detail-title").html(data.subtitle);
    plotDetailBlock.find("header .plot-detail-status").html(data.statusBadge ?? "");
    plotDetailBlock.find("header").append(plotDetailBlock.find("#GROUP_ACTIONS"));
    plotDetailBlock.find("#GROUP_ACTIONS").removeClass("hidden");
    
    /**
     * If we've received a plot id, then we can also edit the entry in the plot
     * list.
     */
    if ( typeof data[ 'PLOT10_ID' ] !== "undefined" ){
      
      /**
       * If we have received an errc field and this field is blank/null/emtpy 
       * (i.e. no error) then we can remove any plot error icon.
       */
      if ( typeof data[ 'PLOT10_ERRC' ] !== "undefined"  &&  !data[ "PLOT10_ERRC" ] ){
        var plotBlockItem = plotBlock.find( ".pgs-item[data-id='" + data.PLOT10_ID + "']" );
        plotBlockItem.find( '.plot-error-icon' ).remove();
      }
    }
    if(onPlotLoaded){
      onPlotLoaded();
    }
  }

  function init(){

    $selector = $(selector);
    projectBlock = $selector.find(".project-list").closest(".card");
    groupBlock = $selector.find(".group-list").closest(".card");
    subgroupBlock = $selector.find(".subgroup-list").closest(".card");
    plotBlock = $selector.find(".plot-list").closest(".card");
    plotDetailBlock = $selector.find(".plot-detail").closest(".card");
    detailBlock = $selector.find("#detail-pgs");
  }

  setPGSBreadcrumb();
  
  return {
    triggerPreSelect: triggerPreSelect,
    updatePlotDetail: updatePlotDetail
  }
}
